module.exports = __webpack_public_path__ + "img/secret_step_5.868ff81f.svg";